<template>
	<header class="hero-banner" :aria-label="t(`${I18N_NS}.hero.ariaLabel`)">
		<img class="hero-banner__bg" :src="bannerImage" :alt="t(`${I18N_NS}.meta.breadcrumb`)" />

		<div class="hero-banner__carousel">
			<Transition name="hero-slide">
				<div
					v-if="activeSlide === 0"
					key="logo"
					class="hero-banner__slide hero-banner__slide--logo"
				>
					<img
						class="hero-banner__logo"
						:class="{ 'hero-banner__logo--en': isEn }"
						:src="heroLogoSrc"
						:alt="t(`${I18N_NS}.meta.breadcrumb`)"
					/>
				</div>

				<div v-else key="text" class="hero-banner__slide hero-banner__slide--text">
					<p class="hero-banner__slogan" :class="{ 'hero-banner__slogan--en': isEn }">
						{{ t(`${I18N_NS}.hero.slogan`) }}
					</p>
				</div>
			</Transition>
		</div>
	</header>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref } from "vue";
import { useI18n } from "~/composables/useI18n";
import bannerImage from "../../images/banner2.png";
import heroLogoTw from "~/assets/images/SeerQtw.svg";
import heroLogoEn from "~/assets/images/SeerQ.svg";

const I18N_NS = "aboutUs";
const { t, locale } = useI18n();
const isEn = computed(() => locale?.value === "en");
const heroLogoSrc = computed(() => (isEn.value ? heroLogoEn : heroLogoTw));

const activeSlide = ref(0);
const SLIDE_INTERVAL = 4000;
let slideTimer = null;

onMounted(() => {
	slideTimer = setInterval(() => {
		activeSlide.value = activeSlide.value === 0 ? 1 : 0;
	}, SLIDE_INTERVAL);
});

onUnmounted(() => {
	if (slideTimer) {
		clearInterval(slideTimer);
		slideTimer = null;
	}
});
</script>

<style lang="scss" scoped>
.hero-banner {
	position: relative;
	width: 100%;
	background: linear-gradient(180deg, #fffdf9 0%, #ffffff 100%);

	&__bg {
		display: block;
		width: 100%;
		height: auto;
	}

	&__carousel {
		position: absolute;
		left: 5%;
		top: 42%;
		transform: translateY(-50%);
		width: 46%;
		height: 130px;
		z-index: 1;
		overflow: hidden;
	}

	&__slide {
		position: absolute;
		top: 0;
		left: 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 100%;
		height: 100%;

		&--logo {
			align-items: flex-start;
		}

		&--text {
			align-items: flex-start;
		}
	}

	&__logo {
		display: block;
		width: 100%;
		max-width: 280px;
		height: auto;

		&--en {
			max-width: 220px;
		}
	}

	&__slogan {
		margin: 0;
		font-family: "Source Han Serif CN", serif;
		font-weight: 700;
		color: #333333;
		line-height: 40px;
		font-size: 32px;
	}
}

.hero-slide-enter-active,
.hero-slide-leave-active {
	transition: transform 0.55s ease;
}

.hero-slide-enter-from {
	transform: translateY(100%);
}

.hero-slide-leave-to {
	transform: translateY(-100%);
}
</style>
